import { useEffect, useRef } from 'react';

import '../../animations/upgrade-styles.css';

import UpgradeSVG from '../../animations/upgrade.svg?url';

const UnderUpdate = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Fetch and insert SVG inline so CSS animations work
        fetch(UpgradeSVG)
            .then((response) => response.text())
            .then((svgText) => {
                if (containerRef.current) {
                    containerRef.current.innerHTML = svgText;
                    const svg = containerRef.current.querySelector('svg');
                    if (svg) {
                        svg.classList.add('animated');
                    }
                }
            });
    }, []);

    return (
        <div className="flex flex-col justify-center items-center bg-background px-4 w-screen h-screen">
            <div className="w-full max-w-2xl">
                <div ref={containerRef}></div>
            </div>
            <div className="mb-8 text-center">
                <h1 className="mb-4 font-bold text-foreground text-4xl">
                    Service Unavailable
                </h1>
                <p className="mb-2 text-muted-foreground text-xl">
                    We're currently performing maintenance
                </p>
                <p className="text-muted-foreground">Please check back later</p>
            </div>
            <div className="bottom-2 absolute">
                <a
                    className="text-muted-foreground text-xs"
                    href="https://storyset.com/technology"
                >
                    Technology illustrations by Storyset
                </a>
            </div>
        </div>
    );
};

export default UnderUpdate;
